import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutocompleteAccountNumberComponent } from './autocomplete-account-number.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [AutocompleteAccountNumberComponent],
  exports: [AutocompleteAccountNumberComponent]
})
export class AutocompleteAccountNumberModule { }



// WEBPACK FOOTER //
// ./src/app/utils/autocomplete-account-number/autocomplete-account-number.module.ts